import Storage from 'BT/lib/LocalStorage';
import ApiService from 'BT/lib/ApiService';

BT.lib = {
	Storage,
	apiCall: new ApiService(),
}
